export type KissDatepickerSelectionMode = `${KissDatepickerSelectionModeEnums}`;
export enum KissDatepickerSelectionModeEnums {
  DATEPICKER = "datepicker",
  RANGE = "range"
}
